import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=d4eb9c70&"
import script from "./BurgerMenu.vue?vue&type=script&lang=js&"
export * from "./BurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports